// IMAGES //
import req_rec from "../../assets/req_rec_logo.png";
import bhpca from "../../assets/bhpca_logo.jpeg";
import zombeeLogo from "../../assets/zombee_logo.png";

// STYLES // 
import "./games.css"

// LOGOS //
import CPLogo from "../CPLogo";
import PixiLogo from "../Logo";
import Logo from "../Logo";
import LogoIMDV from "../LogoIMDV";

// METERS //
import CreationMeter from "../CreationMeter";

export default function Games() {
  return (
    <div id="games">

      <div className="game-card">
        <Logo
          className="logo-spacing"
          size={150}
          rotationSpeed={0.005}
          tint={0x808080}
        />

        <p className="game-description">
          <b>AVENUES & STREETS</b>{" "}
          | The city is full of places to go, but getting there safely takes practice. When a friend of mine, a special education teacher in an adult transition program, approached me about building an educational street-crossing game, I knew I had to be part of it. In Avenues & Streets, students learn to watch traffic, read the signals, and choose the right moment to cross. Built as a playful adventure, each trip across the road gives players another chance to build confidence, sharpen their timing, and practice the everyday skills that help them navigate the world.
          <br />
          <br />
          <b>Genre:</b> Educational Adventure <br />
          <b>Platform:</b> Mobile | Web Browser <br />
          <b>Rating:</b> All Ages <br />
          <b>Release:</b> Fall 2026 <br />
          <b>Status:</b> Beta
        </p>

        <CreationMeter
          humanPercent={100}
          humanLabel="Hand-Drawn Sprites"
          aiLabel="AI-Generated Sprites"
        />
      </div>

      <p className="game-plus">+</p>

      <div className="game-card">
        <Logo
          className="logo-spacing"
          size={150}
          rotationSpeed={0.005}
          tint={0x808080}
        />

        <p className="game-description">
          <b>BECKY SUE'S CUPCAKE JUBILEE</b>{" "}
          | Not in our backyard.
          <br />
          <br />
          <b>Genre:</b> Puzzle | Strategy <br />
          <b>Platform:</b> Mobile <br />
          <b>Rating:</b> Mature (18+) for animated violence, gore, and horror themes. <br />
          <b>Release:</b> Summer 2027 <br />
          <b>Status:</b> Pre-production
        </p>

        <CreationMeter
          humanPercent={100}
          humanLabel="Hand-Drawn Sprites"
          aiLabel="AI-Generated Sprites"
        />
      </div>

      <p className="game-plus">+</p>

      <div className="game-card">
        <a href="https://www.crosstownpublic.com" target="_blank" rel="noreferrer">
          {/* <img className="game-logo" src={req_rec} alt="Crosstown Public logo" /> */}
          <CPLogo
            className="logo-spacing game-logo"
            size={200}
          />
        </a>

        <p className="play-link">Tap Logo to Play</p>

        <p className="game-description">
          <b>
            <a href="https://www.crosstownpublic.com" target="_blank" rel="noreferrer">
              CROSSTOWN PUBLIC
            </a>
          </b>{" "}
          | You and seven of your favorite, comic-book-loving friends have just spent a perfect Sunday afternoon swapping coveted editions, but the library's just closed and your stomachs are rumbling. Thankfully, you know all the best eats in town. Since the city's businesses, employees, and encounters are shuffled each time you play, every trip through Crosstown Public tells a slightly different story. Better hurry before your parents tell you it's time to come home.
          <br />
          <br />
          <b>Genre:</b> Adventure | Beat 'Em Up <br />
          <b>Platform:</b> Web Browser (Keyboard) <br />
          <b>Rating:</b> Teen (13+) for mild violence, risky situations, language, and dark humor. <br />
          <b>Release:</b> Spring 2026<br />
          <b>Status:</b> Beta
        </p>

        <CreationMeter
          humanPercent={56}
          humanLabel="Hand-Drawn Sprites"
          aiLabel="AI-Generated Sprites"
        />
      </div>

      <p className="game-plus">+</p>

      <div className="game-card">
        <a href="https://www.imortidivalpolicella.com" target="_blank" rel="noreferrer">
          {/* <img className="game-logo" src={zombeeLogo} alt="Zombee logo" /> */}
          <LogoIMDV
            className="game-logo"
            size={200}
          />
        </a>

        <p className="play-link">Tap Logo to Play</p>

        <p className="game-description">
          <b>
            <a href="https://www.imortidivalpolicella.com" target="_blank" rel="noreferrer">
              I MORTI DI VALPOLICELLA
            </a>
          </b>{" "}
          | My first "game" and first MERN stack application, originally created as a student project set during a forgotten zombie apocalypse. For now, it'll only <em>consume</em> about two minutes of your life, but I'm planning to expand it into a proper side-scrolling, chaos-fueled splatterfest where you'll probably find yourself rooting for the undead.
          <br />
          <br />
          <b>Genre:</b> Arcade Action | Infection Strategy <br />
          <b>Platform:</b> Mobile | Web Browser (Keyboard) <br />
          <b>Rating:</b> Mature (18+) for animated violence, gore, and horror themes. <br />
          <b>Release:</b> Winter 2023 <br />
          <b>Status:</b> Beta
        </p>

        <CreationMeter
          humanPercent={100}
          humanLabel="Hand-Drawn Sprites"
          aiLabel="AI-Generated Sprites"
        />
      </div>

    </div>
  );
}